import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

// eslint-disable-next-line react/prop-types
export default function CameraDialog({ cameraOpen, cameraError, videoRef, stopCamera, onCapture }) {
  return (
    <Dialog
      visible={cameraOpen}
      onHide={stopCamera}
      header="Take Photo"
      modal
      dismissableMask
      style={{ width: '90vw', maxWidth: '700px' }}
      contentStyle={{ padding: 0, textAlign: 'center' }}
      footer={
        <div className="flex justify-content-center gap-2 p-2">
          <Button
            icon="pi pi-camera"
            label="Capture"
            onClick={onCapture}
            disabled={!!cameraError}
            className="p-button"
          />
          <Button
            icon="pi pi-times"
            label="Cancel"
            onClick={stopCamera}
            className="p-button p-button-outlined"
          />
        </div>
      }
    >
      {cameraError
        ? (
          <div className="p-4">
            <i className="pi pi-exclamation-triangle text-4xl mb-3" style={{ display: 'block' }} />
            <p>{cameraError}</p>
          </div>
        )
        : (
          <video ref={videoRef} autoPlay playsInline muted style={{ width: '100%', display: 'block' }} />
        )}
    </Dialog>
  );
}
